/* Source: /home/sidsolaiyappan/skooch_ai/shared/oauth_session.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { jacLogin, jacSignup } from "@jac/runtime";
function deriveOAuthJacPassword(uid) {
  return (("Goog!" + String((uid || ""))) + "#sk8Aa1");
}
function deriveOAuthJacUsername(uid) {
  return (("goog-" + String((uid || ""))) + "@oauth.skooch.ai");
}
async function ensureJacSessionForOAuth(email, uid) {
  if (!uid) {
    return false;
  }
  if (window.__skoochOAuthJacBound) {
    return true;
  }
  let _user = deriveOAuthJacUsername(uid);
  let _pw = deriveOAuthJacPassword(uid);
  try {
    let _ok = await jacLogin(_user, _pw);
    if (!_ok) {
      await jacSignup(_user, _pw);
      _ok = await jacLogin(_user, _pw);
    }
    if (_ok) {
      window.__skoochOAuthJacBound = true;
    }
    return (_ok ? true : false);
  } catch (__jac_e) {
    if (true) {
      let _e1 = __jac_e;
      console.log("ensureJacSessionForOAuth (non-fatal):", _e1);
    } else {
      throw __jac_e;
    }
  }
  return false;
}
export {deriveOAuthJacPassword, deriveOAuthJacUsername, ensureJacSessionForOAuth};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:deriveOAuthJacPassword": {"is_writer": false, "touches": ["*"]}, "func:deriveOAuthJacUsername": {"is_writer": false, "touches": ["*"]}, "func:ensureJacSessionForOAuth": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=oauth_session.js.map
